import React, { FC, useState } from 'react'
import ModalDialog from 'shared/modal/dialog';
import { Button } from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import useFqdn from '../../hooks/useFqdn'

export const MenuActions:FC = () => {
    const { t } = useTranslation();
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const {
        selectedItem, privileges, goToEditSelectedFqdnPage, onDelete
    } = useFqdn();

    if (!selectedItem){
        return null
    }

    return (
      <div data-testid="XdpMenu" className="fqdn-action-menu">
        {privileges.create && (
        <Button
          style={{ marginRight: '1rem' }}
          className="fqdn-action-menu-button"
          data-testid="edit-fqdn-button"
          text={t('collectionFunction.grid.edit')}
          onClick={goToEditSelectedFqdnPage}
        />
        )}
        {privileges.delete && (
        <Button
          className="fqdn-action-menu-button"
          data-testid="delete-fqdn-button"
          text={t('collectionFunction.grid.delete')}
          onClick={() => setIsDeleteDialogOpen(true)}
        />
        )}
        <ModalDialog
          width="500px"
          isOpen={isDeleteDialogOpen}
          title={t('fqdn.dialog.delete')}
          displayMessage={
            t('collectionFunction.deletePopup.message', { name: selectedItem.fsId })
            }
          actionText={t('collectionFunction.deletePopup.action')}
          onSubmit={onDelete}
          onClose={() => setIsDeleteDialogOpen(false)}
        />
      </div>
)
}

export default MenuActions;
